import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
  }

  .error-message {
    display: flex;
    align-items: center;
    padding: 0.75rem;
    margin-bottom: 1rem;
    background: var(--sl-color-danger-50);
    border: 1px solid var(--sl-color-danger-200);
    border-radius: 6px;
    color: var(--sl-color-danger-700);
    font-size: 0.875rem;
  }

  .error-message sl-icon {
    margin-right: 0.5rem;
  }

  .part-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid var(--sl-color-neutral-200);
  }

  .part-header h2 {
    margin: 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.5rem;
    font-weight: 600;
  }

  .part-status-badge {
    display: flex;
    align-items: center;
  }

  .part-fields {
    margin-bottom: 1rem;
  }

  .field-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
    padding: 0.75rem;
    background: var(--sl-color-neutral-50);
    border-radius: 8px;
  }

  .field-label {
    min-width: 120px;
    font-weight: 600;
    color: var(--sl-color-neutral-700);
  }

  .field-value {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .field-value sl-input,
  .field-value sl-select {
    flex: 1;
    min-width: 200px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
  }

  /* Shoelace component overrides */
  sl-dialog {
    --width: 900px;
  }

  sl-button {
    min-width: 120px;
  }
`;
